import {useEffect, useState} from 'react'

/**
 * @typedef {Object} ScriptsLoaded
 * @property {string} src
 * @property {boolean} hasLoaded
 */

/**
 * @type {ScriptsLoaded}
 */
let scriptsLoaded = {}

/**
 * @typedef {Object} UseScriptOptions
 * @prop {string} src - script src
 * @prop {string=} text - script inner text
 * @prop {boolean=} forceLoad - force script to rerun
 */

/**
 * Hook to allow for conditional rendering after loading some outside JS file
 * @param {UseScriptOptions} Options
 * @returns {[loaded: boolean]}
 */
export default function useScript ({src, text = '', forceLoad = false}) {
  const [loaded, setLoaded] = useState(false)

  if (src && scriptsLoaded[src] && !loaded) setLoaded(true)

  useEffect(() => {
    let script

    if (src && (!loaded || forceLoad)) {
      script = document.createElement('script')
      script.src = src
      script.text = text
      script.async = true
      script.onload = () => {
        scriptsLoaded[src] = true
        setLoaded(true)
      }
      document.body.appendChild(script)
    }

    return () => {
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [src, text, loaded, scriptsLoaded[src]], forceLoad)

  return [loaded]
}
